import g from '#core/global';
import config from '#core/config';
import load from '#core/load';
import cookie from '#core/cookie';
import util from '#core/util';


const cookie_prefix = 'subscribe_popup';
const dismissed_value = 'dismissed';
const id_attr = 'id';
const page_delay_attr = 'data-popup-page-delay';
const days_attr = 'data-popup-days';
const max_attr = 'data-popup-max-appearances';
const idle_attr = 'data-popup-idle';
const is_active_attr = 'data-is-active';
const close_$ = '.close-subscribe-popup';
const popup_$ = '.subscribe-popup';


let has_popup = false;
let user_has_interacted = false;


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('subscribe-popup')) return false;

		load.all(() => {
			has_popup = assign_elements();
			if (!has_popup) return false;

			start();
		});
	},

};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_popup) return true;

	const $popups = document.querySelectorAll(popup_$);
	if (!$popups.length) return false;

	['mousedown', 'touchstart', 'keydown'].forEach(event_type => {
		document.addEventListener(event_type, function listener() {
			user_has_interacted = true;
			document.removeEventListener(event_type, listener);
		});
	});

	$popups.forEach($popup => {
		const $close = $popup.querySelector(close_$);
		if ($close) {
			$close.addEventListener(g.click_e, e => {
				e.preventDefault();
				dismiss($popup);
			});
		}
	});

	return true;
}


/**
 * Start countdown to showing popup
 */
function start() {
	const $popups = document.querySelectorAll(popup_$);
	$popups.forEach($popup => {
		const delay = parseFloat($popup.getAttribute(page_delay_attr)) || 0;
		setTimeout(() => {
			show_on_timer($popup);
		}, Math.max(delay, 0) * 1000);
	});
}


/**
 * Show popup automatically after delay
 * @param {element} $popup
 */
function show_on_timer($popup) {
	const popup_id = $popup.getAttribute(id_attr);
	const count_cookie = get_cookie_name(popup_id);
	const show_only_when_idle = $popup.hasAttribute(idle_attr);

	if (is_dismissed(count_cookie)) return false;
	if (reached_max_appearances($popup, count_cookie)) return false;

	if (show_only_when_idle && user_has_interacted) return false;

	increment_appearances($popup, count_cookie);
	show($popup);
}


/**
 * Show popup
 * @param {element} $popup
 */
function show($popup) {
	$popup.setAttribute(is_active_attr, g.true_s);
}


/**
 * Dismiss popup and record dismissal cookie
 * @param {element} $popup
 */
function dismiss($popup) {
	const popup_id = $popup.getAttribute(id_attr);
	const count_cookie = get_cookie_name(popup_id);
	const days = parseInt($popup.getAttribute(days_attr));

	$popup.setAttribute(is_active_attr, g.false_s);
	cookie.create(count_cookie, dismissed_value, days);
}


/**
 * Has the user already dismissed the popup?
 * @param {string} cookie_name
 * @return {boolean}
 */
function is_dismissed(cookie_name) {
	return cookie.read(cookie_name) === dismissed_value;
}


/**
 * Has the popup reached its max appearance count?
 * @param {element} $popup
 * @param {string} cookie_name
 * @return {boolean}
 */
function reached_max_appearances($popup, cookie_name) {
	const max = parseInt($popup.getAttribute(max_attr)) || 0;
	if (!max) return false;

	const count = parseInt(cookie.read(cookie_name)) || 0;
	return count >= max;
}


/**
 * Increment the appearance count cookie
 * @param {element} $popup
 * @param {string} cookie_name
 */
function increment_appearances($popup, cookie_name) {
	const days = parseInt($popup.getAttribute(days_attr));
	const current = parseInt(cookie.read(cookie_name)) || 0;
	cookie.create(cookie_name, String(current + 1), days);
}


/**
 * Get cookie name
 * @param {string} id
 * @return {string}
 */
function get_cookie_name(id) {
	return util.snake(`${config.site_name}_${cookie_prefix}_${id}`);
}
